import { ProductOptionValue } from './ProductOptionValue';
import { ProductOptionValuesLabel } from '../ProductOptionValuesLabel';

export function ProductOptionValues({
  enabledsizeGuide,
  inventory,
  inventoryFetched,
  product,
  name,
  selectedOptions,
  setSelectedOptions,
  values,
  sizeGuides,
  isSoldOut,
  moreThanTwoOptions,
  isSecondOption,
  keysWithMatchingCount,
  needsSelection,
  optionChanges,
  setOptionChanges,
}) {
  const productOrGroupingValues = product.grouping?.isTransformed
    ? product.grouping.optionsMap[name]
    : values;

  const selected = optionChanges.hasOwnProperty(name) && optionChanges[name] === true;

  return (
    <div>
      <ProductOptionValuesLabel
        enabledsizeGuide={enabledsizeGuide}
        name={name}
        productType={product.productType}
        sizeGuides={sizeGuides}
        selectedValue={selectedOptions?.[name]}
        selected={selected}
      />

      <ul className="flex flex-wrap gap-[5px]">
        {productOrGroupingValues?.map((value) => {
          const isSelected = selectedOptions?.[name] === value;
          const secondOptionIsSoldOut = moreThanTwoOptions && isSecondOption && keysWithMatchingCount.includes(value);

          return (
            <li key={value}>
              <ProductOptionValue
                inventory={inventory}
                isLoading={!inventoryFetched}
                isSelected={isSelected}
                selected={selected}
                name={name}
                product={product}
                selectedOptions={selectedOptions}
                setSelectedOptions={setSelectedOptions}
                value={value}
                isSoldOut={isSoldOut}
                moreThanTwoOptions={moreThanTwoOptions}
                secondOptionIsSoldOut={secondOptionIsSoldOut}
                needsSelection={needsSelection}
                optionChanges={optionChanges}
                setOptionChanges={setOptionChanges}
              />
            </li>
          );
        })}
      </ul>
    </div>
  );
}

ProductOptionValues.displayName = 'ProductOptionValues';
